
import { I18n } from '@aws-amplify/core';
import { Button, TextField } from '@aws-amplify/ui-react';
import { CircularProgress } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Auth } from 'aws-amplify';
import React from 'react';
import { connect } from 'react-redux';
import { Navigate } from "react-router-dom";
import { Branding } from '../../branding';
import { setUser } from '../../redux/actions';
import DividerWithText from '../DividerWithText/DividerWithText';
import Footer from '../Footer/Footer';
import { verifyActivationCode } from '../LandingPage/helpers/activationTokenHelper';
import LinkMyAccount from "../LinkMyAccount/LinkMyAccount";


const useStyles = makeStyles((theme) => ({

	rootGrid: {
		marginTop: theme.spacing(10),
		paddingBottom: theme.spacing(3),
	},
	grid: {
		justifyContent: 'center',
	},
	box: {
		width: '90%',
		maxWidth: 650,
	},
	card: {
		minWidth: "25em",
		maxWidth: '27em',
		justifyContent: 'center',
	},
	cardMedia: {
		width: 200,
		height: 90,
		backgroundSize: 'contain',
	},
	cardHeader: {
		paddingBottom: 0
	},
	cardContent: {
		justifyContent: 'center',
		padding: "4em 2em",
		textAlign: 'center',
		"&:last-child": {
			paddingBottom: theme.spacing(5)
		}
	},
	boxExpandIdp: {
		textAlign: 'center',
	},
	chipExpand: {
		backgroundColor: Branding.secondary,
		color: Branding.white,
		'&:hover': {
			backgroundColor: Branding.secondary,
			opacity: Branding.opacityHover,
		},
	},
	expandIcon: {
		color: Branding.white,
	},
	divider: {
		marginBottom: theme.spacing(2)
	},
	typoToS: {
		paddingTop: theme.spacing(3),

	},
	linkTos: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.secondary,
		'&:hover': {
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	linkImprint: {
		fontSize: 14,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	link: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.link,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	midBul: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		color: Branding.secondary,
	},
	button: {
		width: "100%",
		borderRadius: "0px",
		paddingBottom: theme.spacing(1),
		paddingTop: theme.spacing(1),
		marginTop: theme.spacing(2),
	},
	errorMessage: {
		color: "red",
		marginTop: theme.spacing(1),
		fontWeight: "bold",
		fontSize: "12px"
	}
}));

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
		user: state.app.user,
		tos: state.app.tos
	}
}

const ActivationPage = (props) => {
	const classes = useStyles();
	const [token, setToken] = React.useState(sessionStorage.getItem("activationToken") || '');
	const [sessionActivationToken, setSessionActivationToken] = React.useState(sessionStorage.getItem("activationToken") || null);
	const [errorMessage, setErrorMessage] = React.useState({});
	const [isLoading, setIsLoading] = React.useState(false);
	const [isValidating, setIsValidating] = React.useState(false);
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		var initialValidate = async () => {
			try {
				// this user already has token.
				if (props.user && props.user.attributes && props.user.attributes["custom:activation_token"]) {
					return;
				}
				if (!isValidating)
					setIsLoading(true);
				await verifyActivationCode(sessionActivationToken);
				await Auth.updateUserAttributes(props.user, { "custom:activation_token": sessionActivationToken });
				const unCachedUser = await Auth.currentAuthenticatedUser({ bypassCache: true });
				setIsLoading(false);
				setIsValidating(false);
				props.setUser(unCachedUser);
				return;
			} catch (excep) {
				setErrorMessage({ message: "Invalid Activation Code: " + sessionActivationToken, type: "activationCode" });
				setIsLoading(false);
				setToken("");
				setIsValidating(false);
				return;
			}

		}
		// if user has activation token already, just redirect to bronn
		if (sessionActivationToken) {
			initialValidate();
		}

	}, [sessionActivationToken])


	const handleChange = (event) => {
		setToken(event.target.value);
		if (token && token.length > 0)
			return setErrorMessage(null)
	};

	const handleClick = async () => {

		if (!token || token.length <= 3)
			return setErrorMessage({ message: "Please enter valid activation code!", type: "activationCode" })
		setIsValidating(true);
		setSessionActivationToken(token);
	}

	const handleLinkMyAccountButtonClick = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	return (
		props.user && props.user.attributes && props.user.attributes && props.user.attributes["custom:activation_token"]
			? <Navigate to="/launch" />
			:
			<div>

				<Grid
					container
					spacing={0}
					direction="column"
					alignItems="center"
					justifyContent="center"
					className={classes.rootGrid}
				>
					<CardMedia
						className={classes.cardMedia}
						image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
						title={Branding.appName}
					/>


				</Grid>

				{!isLoading ?
					<Grid container className={classes.grid}>
						<Card variant="outlined" className={classes.card}>
							<CardContent className={classes.cardContent}>

								<TextField className={"input activiationCode"} value={token} onPaste={handleChange} onChange={handleChange} id="activationCode"
									type="text" placeholder="Enter your activation code here"
									style={{ fontSize: "12px" }}
									name="activiationCode" required>
								</TextField>

								<Typography style={{ textAlign: "right" }}>
									<Link
										href="https://resources.youscience.com/buy"
										target="_blank"
										underline='always'
										style={{ fontSize: "10px" }}
										color="primary"
										className={classes.linkTos}
									>Purchase my licence</Link>

								</Typography>

								{errorMessage && errorMessage.type && errorMessage.type === "activationCode" ?
									<Typography className={classes.errorMessage}>{errorMessage.message} </Typography>
									: null
								}

								<Button onClick={handleClick} variation="primary" isFullWidth={true} isLoading={isValidating} className={classes.button}
									loadingText="Validating..."> Activate </Button>

								<DividerWithText borderColor="#c15ab3">
									<div style={{ fontSize: "12px", fontWeight: "bold" }}>	{I18n.get("LANDING_PAGE_DIVIDER_TEXT")} </div>
								</DividerWithText>

								<Typography style={{ fontSize: "12px", fontWeight: 700, color: Branding.secondary, marginTop: "1em", marginBottom: "1em" }}>
									You can link your existing YouScience account by clicking the below button.
								</Typography>

								<Button onClick={handleLinkMyAccountButtonClick} style={{ fontSize: "12px", fontWeight: "bold", color: Branding.lightBlack, marginTop: "1em", marginBottom: "1em" }} variation="info" isFullWidth={true} className={classes.link}> Link with my existing account </Button>

								<Typography>
									<Link
										href="/logout"
										underline="always"
										className={classes.link}
									>
										{I18n.get("HEADER_MENU_ITEM_LOGOUT")}
									</Link>

								</Typography>

							</CardContent>
						</Card >
					</Grid>
					:
					<Grid container className={classes.grid}>
						<CircularProgress variant='indeterminate' thickness={3} size={"2em"} />
					</Grid>
				}
				<Footer></Footer>
				<LinkMyAccount open={open} onClose={handleClose} />

			</div >
	);
}

export default connect(mapStateToProps, { setUser })(ActivationPage);
